import { useQuery } from "@tanstack/react-query";
import { isLek } from "src/helpers/services";
import newApi from "src/newApi";

import options from "./defaultOptions";

export type Consultant = {
	id: number;
	name: string;
};

// konsultanci istnieją tylko na LEK/PES — na LDEK i ExamLek endpoint zwraca 400
export function useGetConsultants() {
	return useQuery<Consultant[]>({
		queryKey: ["consultants"],
		queryFn: () => newApi.getConsultants(),
		...options,
		enabled: isLek(),
	});
}
